import { render, staticRenderFns } from "./PracticeExplanation.vue?vue&type=template&id=5af7df02&"
import script from "./PracticeExplanation.vue?vue&type=script&lang=ts&"
export * from "./PracticeExplanation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports